import { render, staticRenderFns } from "./InOutBadge.vue?vue&type=template&id=ff093568"
import script from "./InOutBadge.vue?vue&type=script&lang=js"
export * from "./InOutBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports